import { GENERAL_GITHUB_DETAILS_URL, MARKET_CARDS_URL } from 'constants/constants';

/**
 * @description All Markets Card JSON is currently being served via Github pages API.
 * @see [API Codebase](https://github.com/delta-exchange/delta-exchange.github.io/tree/master/data/allMarketsCards)
 */
const getAllMarketsCards = () => {
  return fetch(MARKET_CARDS_URL)
    .then(response => {
      if (!response.ok) {
        throw new Error('Request Failed');
      }
      return response.json();
    })
    .then(payload => {
      const { desktop, mobile } = payload;
      if (Array.isArray(desktop) && Array.isArray(mobile)) {
        return { desktop, mobile };
      }
      throw new Error('Field validations failed');
    });
};

/**
 * @description This JSON, which includes various general details such as banners, links, and continuously updated information, is currently being delivered through the GitHub Pages API.
 * @see [API Codebase](https://github.com/delta-exchange/delta-exchange.github.io/tree/master/data/general)
 */

const getGeneralDetails = () => {
  return fetch(GENERAL_GITHUB_DETAILS_URL).then(response => {
    if (!response.ok) {
      throw new Error('Request Failed');
    }
    return response.json();
  });
};

export { getAllMarketsCards, getGeneralDetails };
